module.exports = __webpack_public_path__ + "img/gaming.76cb8a00.png";